import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export { supabaseUrl, supabaseAnonKey };

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Usuario {
  id: string;
  nombre: string;
  usuario: string;
  rol: string;
  created_at: string;
}

export interface Categoria {
  id: string;
  nombre: string;
  descripcion: string;
  created_at: string;
}

export interface Producto {
  id: string;
  nombre: string;
  descripcion: string;
  tipo_producto?: string | null;
  categoria_id?: string | null;
  marca: string;
  modelo_compatible: string;
  codigo_barras: string;
  codigo_interno: string;
  precio_compra: number;
  precio_venta: number;
  stock: number;
  stock_minimo: number;
  costo_promedio?: number;
  proveedor: string;
  ubicacion: string;
  imagen_url: string;
  created_at: string;
  updated_at: string;
}

export interface Venta {
  id: string;
  fecha: string;
  total: number;
  metodo_pago: string;
  monto_recibido: number;
  cambio: number;
  nombre_factura: string;
  nit: string;
  comprobante_url: string;
  usuario_id: string;
  created_at: string;
}

export interface DetalleVenta {
  id: string;
  venta_id: string;
  producto_id: string;
  cantidad: number;
  precio_unitario: number;
  subtotal: number;
}

export interface Auditoria {
  id: string;
  usuario_id: string;
  accion: string;
  modulo: string;
  detalle: string;
  created_at: string;
}

export interface Kardex {
  id: string;
  producto_id: string;
  tipo: string;
  cantidad: number;
  motivo: string;
  usuario_id: string;
  created_at: string;
  costo_unitario?: number | null;
  valor_entrada?: number | null;
  valor_salida?: number | null;
  saldo_fisico?: number | null;
  cpp_aplicado?: number | null;
  cpp_resultante?: number | null;
  valor_resultante?: number | null;
  referencia?: string | null;
  operacion_id?: string | null;
}

export interface Proveedor {
  id: string;
  nombre: string;
  contacto: string;
  telefono: string;
  email: string;
  direccion: string;
  created_at: string;
}